import documentsService from '../services/documentsService';

const state = {
  documentUrls: [],
};

const getters = {
  documentUrls: state => state.documentUrls,
};

const mutations = {
  setDocumentUrls(state, urls) {
    state.documentUrls = urls;
  },
};

const actions = {
  async createDocumentUrls({ commit }, activityUids) {
    try {
      const response = await documentsService.createDocumentUrls(activityUids);
      if (response.success) {
        commit('setDocumentUrls', response.urls);
      }
    } catch (e) {
      console.error(e);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
